import { render, staticRenderFns } from "./SizedList.vue?vue&type=template&id=ddf07d20&scoped=true&"
import script from "./SizedList.vue?vue&type=script&lang=js&"
export * from "./SizedList.vue?vue&type=script&lang=js&"
import style0 from "./SizedList.vue?vue&type=style&index=0&id=ddf07d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddf07d20",
  null
  
)

export default component.exports